import { ChangeEvent, useMemo, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';

import styles from './AddCountry.module.scss';
import { IAddCountryProps } from './IAddCountryProps';
import { CountryRequestModel } from '../../../models/countries/CountryRequestModel';
import { HttpService, IHttpService } from '../../../services/httpService';
import {
  INotifierService,
  NotifierService,
} from '../../../services/notifierService';

const AddCountry = ({ setShouldReload }: IAddCountryProps): JSX.Element => {
  const [code, setCode] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const httpService: IHttpService = useMemo(() => new HttpService(), []);
  const notifierService: INotifierService = useMemo(
    () => new NotifierService(),
    [],
  );

  const resetDialog = (): void => {
    setCode('');
    setDescription('');
    setIsVisible(false);
    setIsLoading(false);
  };

  const handleAddBrandCountry = async (): Promise<void> => {
    setIsLoading(true);

    const country: CountryRequestModel = {
      code,
      description,
    };

    try {
      await httpService.post(
        'countries',
        JSON.stringify(country),
        undefined,
        false,
      );

      setShouldReload(true);
      resetDialog();
    } catch (err) {
      notifierService.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const addDialogFooter: JSX.Element = (
    <>
      <button
        className="btn primary"
        onClick={handleAddBrandCountry}
        disabled={!code || !description}
      >
        Add
      </button>
      <button className="btn secondary" onClick={resetDialog}>
        Cancel
      </button>
    </>
  );

  const pendingFooter: JSX.Element = (
    <div className={styles.dialogFooter}>
      <p>Creating Country...</p>
      <ProgressSpinner />
    </div>
  );

  return (
    <>
      <button
        className={`${styles.addButton} btn primary`}
        onClick={() => setIsVisible(true)}
      >
        Add Country
      </button>

      <Dialog
        className={styles.dialog}
        header="Add Country"
        visible={isVisible}
        onHide={resetDialog}
        footer={isLoading ? pendingFooter : addDialogFooter}
        baseZIndex={9999}
      >
        <div className={styles.dialogContent}>
          <label htmlFor="code">Code</label>
          <InputText
            id="code"
            placeholder="Code"
            value={code}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setCode(e.target.value);
            }}
          />
        </div>

        <div className={styles.dialogContent}>
          <label htmlFor="description">Description</label>
          <InputText
            id="description"
            placeholder="Description"
            value={description}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setDescription(e.target.value);
            }}
          />
        </div>
      </Dialog>
    </>
  );
};

export default AddCountry;
